
const icons = {
	action: 'fa-bolt',
	'action-drop': 'fa-caret-square-down',
	add: 'fa-plus-circle',
	alert: 'fa-exclamation-triangle',
	clone: 'fa-clone',
	close: 'fa-times',
	code: 'fa-brackets-curly',
	confirm: 'fa-check',
	danger: 'fa-exclamation-circle',
	'debug-lines': 'fa-border-all',
	deploy: 'fa-play',
	domain: 'fa-ethernet',
	download: 'fa-folder-download',
	dropdown: 'fa-angle-down',
	editor:'fa-edit',
	'group-open': 'fa-angle-right',
	'group-close': 'fa-angle-down',
	highlight: 'fa-highlighter',
	info: 'fa-info-circle',
	invisible: 'fa-eye-slash',
	root: 'fa-carrot',
	layer: 'fa-layer-group',
	'layer-background': 'fa-rectangle-landscape',
	'layer-circle': 'fa-drafting-compass',
	'layer-fill': 'fa-fill-drip',
	'layer-heatmap': 'fa-burn',
	'layer-hillshade': 'fa-mountains',
	'layer-line': 'fa-pen-nib',
	'layer-raster': 'fa-satellite',
	'layer-symbol': 'fa-text',
	location: 'fa-location',

	'map-focus': 'fa-map-marker',
	refresh: 'fa-redo',
	remove: 'fa-trash',
	required: 'fa-asterisk',
	scratch: 'fa-egg',
	search: 'fa-search',
	source: 'fa-server',
	save: 'fa-save',
	style: 'fa-brush',
	styles: 'fa-globe-americas',
	settings: 'fa-cog',
	token: 'fa-key',
	update: 'fa-wrench',
	upload: 'fa-folder-upload',
	visible: 'fa-eye',
}

const weights = {
	solid: 'fas',
	regular: 'far',
	light: 'fal',
	duo: 'fad',
	brand: 'fab',
}

const weightDefault = 'regular'

export default {
	icons,
	weightDefault,
	weights,
}